import dataSecurity from '@/menus/system/base-data/data-security.ts';
import type { Menu } from '@/menus/types.ts';
import carModelLibrary from './car-model-library.ts';
import currency from './currency.ts';
import dailyExchangeRate from './daily-exchange-rate.ts';
import docxTemplate from './docx-template.ts';
import exportCountry from './export-country.ts';
import exportPort from './export-port.ts';
import exportTradeMethod from './export-trade-method.ts';
import paymentItem from './payment-item.ts';
import person from './person.ts';

export default [
  {
    code: 'BASE_DATA',
    icon: 'menu-base-data',
    label: '基础数据',
    remark: '维护公司信息、车型、交接人等基础数据',
    children: [
      ...dailyExchangeRate,
      ...carModelLibrary,
      ...paymentItem,
      ...exportCountry,
      ...exportPort,
      ...currency,
      ...exportTradeMethod,
      ...person,
      ...docxTemplate,
      ...dataSecurity,
    ],
  },
] satisfies Menu[];
